import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";

export const Ellipsis = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
